import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Grid from "@mui/material/Grid2";
import { Container, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './Navigation.css';
import Logo from "../../assets/images/stellbudy-logo.png";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const hasSubMenu = (index) => {
    return index === 1; // Index 1 corresponds to "About" with submenu
  };

  const handleDropdownToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className="navigation">
      <Container maxWidth="lg">
        <Grid className="nav-container" container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid size={{ xs: 12, md: 4 }}>
            <Link to="/" className="logo">
              <img src={Logo} alt="Steelbudy Logo" />
            </Link>
            <button
              className="mobile-menu-button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
            </button>
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <li>
                <Link
                  to="/"
                  className={isActive('/') ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li className="dropdown">
                <div className="dropdown-toggle">
                  <Link
                    to="/about"
                    className={isActive('/about') ? 'active' : ''}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    About
                  </Link>
                  {hasSubMenu(1) && (
                    <IconButton
                      className="dropdown-toggle-button"
                      onClick={handleDropdownToggle}
                      aria-expanded={isDropdownOpen}
                      aria-label="Toggle dropdown"
                    >
                      <ArrowDropDownIcon className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`} />
                    </IconButton>
                  )}
                </div>
                <ul className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
                  <li>
                    <Link
                      to="/about"
                      className={isActive('/about') ? 'active' : ''}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsDropdownOpen(false);
                      }}
                    >
                      About Steelbuddy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/vision-mission"
                      className={isActive('/vision-mission') ? 'active' : ''}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsDropdownOpen(false);
                      }}
                    >
                      Vision & Mission
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/leadership"
                      className={isActive('/leadership') ? 'active' : ''}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsDropdownOpen(false);
                      }}
                    >
                      Leadership
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/team"
                      className={isActive('/team') ? 'active' : ''}
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsDropdownOpen(false);
                      }}
                    >
                      Team
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={isActive('/contact') ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/enquiry"
                  className={isActive('/enquiry') ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Enquiries
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Container>
    </nav>
  );
};

export default Navigation;